export enum AgentState {
    Idle = 1,
    Waiting,
    Streaming,
}